module.exports = __webpack_public_path__ + "img/little-screenshot.23696ba2.jpg";